import React, { Component } from 'react';
import { Link } from "gatsby";

// Easy way of just controlling globally whether we show this or not.
// Can become much more nuanced of course, but today this is fine.
const isActive = false;

class AlertBar extends Component {
  render() {
    return isActive ? (
      <div className="tc pv3 ph4 navy" style={{ backgroundColor: '#9bdad9' }}>
        <svg
          className="w1 mr3"
          data-icon="info"
          viewBox="0 0 32 32"
          style={{ fill: 'currentcolor' }}
        >
          <title>info icon</title>
          <path d="M16 0 A16 16 0 0 1 16 32 A16 16 0 0 1 16 0 M19 15 L13 15 L13 26 L19 26 z M16 6 A3 3 0 0 0 16 12 A3 3 0 0 0 16 6" />
        </svg>
        Perspexi Labs is now O3! &nbsp; 🎉 &nbsp;
        <Link to="/blog/2018-08-28-perspexi-labs-is-now-o3/">
          Read more about the rebrand on our blog.
        </Link>
      </div>
    ) : null;
  }
}

export default AlertBar;
